import { DataActiveStatusEnum } from "../../Category/types";
import { CampaignState, IData } from "../types";

export const defaultFormData: IData = {
  _id: "",
  createdAt: "",
  updatedAt: "",
  title: "",
  status: DataActiveStatusEnum.ACTIVE,
  featuredImage: "",
  link: "",
};

export const initialState: CampaignState = {
  formData: { ...defaultFormData },
  list: [],
  allList: [],
  loading: false,
  buttonLoading: false,
  toggleLoading: false,
  search: "",
  pageNo: 1,
  pageSize: 30,
  totalRow: 0,
  orderBy: "",
  orderDir: "",
};
